import * as t from 'io-ts';
import * as Either from 'fp-ts/Either';
import { identity, pipe } from 'fp-ts/lib/function';
import * as ErrorAsync from '../ErrorAsync';
import { decodeWith } from '../Decoding';
import * as Http from '../http/HttpClient';
import { getCookiesString } from '../Cookie';
export const UserProfile = t.type({
    id: t.number,
    unpaid_orders: t.number,
    orders: t.number,
    is_seller: t.boolean,
    unread_message_count: t.number,
    display_name: t.union([t.null, t.undefined, t.string]),
    account_verified: t.boolean,
    live_lots: t.number,
    sold_lots: t.number,
});
export const UserProfileResponse = t.type({
    profile: UserProfile,
});
/**
 * Fetches the current user profile.
 *
 * @example
 *
 * import { getCurrentUserProfile } from '@catawiki/runtime-toolkit';
 *
 * const options = {
 *  host: 'example.com',
 *  app: 'test',
 *  authToken: 'auth-token',
 *  baseDomain: 'https://api.example.com';
 * };
 *
 * const currentUserProfile = await getCurrentUserProfile(options);
 *
 * expect(Either.isLeft(currentUserProfile)).toBe(true);
 *
 * @param options - The options for fetching the current user profile.
 * @returns The current user profile.
 */
export const getCurrentUserProfile = (options = {}) => {
    const { host, app, authToken, context, baseApiDomain } = options;
    const url = `${baseApiDomain || ''}/accounts/api/v1/users/me/profile`;
    const isServerSide = host && app && authToken && context;
    return pipe(Http.get(url), 
    // client side headers are set in the browser
    // so we don't need to set them here
    isServerSide
        ? Http.setHeaders({ cookie: getCookiesString(context) })
        : identity, isServerSide
        ? Http.setServerHeaders({
            host,
            app,
            authToken,
        })
        : identity, Http.send())
        .then(decodeWith(UserProfileResponse))
        .then(Either.map(({ profile }) => profile))
        .catch(ErrorAsync.errorToLeft);
};
